export interface TrafficCenter {
    name: string;
}

const trafficCenters: TrafficCenter[] = [
    {name: 'VCMN'},
    {name: 'VCNON'},
    {name: 'VCNWN'},
    {name: 'VCZN'},
    {name: 'VCZWN'},
];

export default trafficCenters;